export interface ExternalServicesAvailability {
    ibanValidator: IbanValidatorService;
}

export interface IbanValidatorService {
    enabled: boolean;
}

export enum ExternalServicesErrors {
    ADD_NEW_BANK_SERVICE_ISSUE = 'external_service_connection_issue'
}
